import PropTypes from "prop-types";
//
import enLocale from "date-fns/locale/en-US";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

DatePickerLocalizationProvider.propTypes = {
  children: PropTypes.node,
};

export default function DatePickerLocalizationProvider({ children }) {
  return (
    // eslint-disable-next-line import/namespace
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enLocale.default}>
      {children}
    </LocalizationProvider>
  );
}
